var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-player-widget',{attrs:{"id":_vm.asset.id,"playerType":_vm.asset.type,"consentHtml":_vm.config.consentHtml}})}
var staticRenderFns = []

export { render, staticRenderFns }